<div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
  <div
    class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-container shrink-0"
  >
    <mat-icon class="text-on-primary-container text-[20px]! w-5! h-5!">new_releases</mat-icon>
  </div>
  <div>
    <h2 class="text-lg font-medium leading-tight">Co je nového</h2>
    <p class="text-sm text-on-surface-variant mt-0.5">Přehled novinek od vaší poslední návštěvy</p>
  </div>
</div>

<!-- Material zeroes the content's bottom padding when the dialog has actions. -->
<mat-dialog-content class="pb-5!">
  <app-release-notes-list [notes]="notes" (linkFollowed)="dialogRef.close()" />
</mat-dialog-content>

<mat-dialog-actions class="justify-between! border-t border-outline-variant!">
  <a matButton routerLink="/co-je-noveho" (click)="closeIfInPlace($event)">Všechny novinky</a>
  <button matButton="filled" (click)="dialogRef.close()">Rozumím</button>
</mat-dialog-actions>
